import React, { useState } from 'react';
import {payload} from "../../widgets/custom/popup-details/mockData"


export interface IDocLinkListContext {
	data:any[]
}

export const DocLinkListContext:any = React.createContext<IDocLinkListContext>({} as IDocLinkListContext);
export const DocLinkListContextProvider = (props: { children: React.ReactNode }) => {
	const [docLinkData, setdocLinkData] = useState<any[]>([]);
	return (
		<DocLinkListContext.Provider
			value={{
				data: docLinkData,
				set: (e:any) => {
					setdocLinkData(e);
				},
			}}
		>
			{props.children}
		</DocLinkListContext.Provider>
	);

};